module.exports = require("./fr-NE.js");